import { IComponentController, IComponentOptions } from 'angular';

import templateUrl from './agent-booking-visio-qualification.component.ajs.html';

const MODULE_NAME = 'agentBookingVisioQualification';

class AgentBookingVisioQualificationCtrl implements IComponentController {
  public name = MODULE_NAME;

  responseId: string;

  $onInit() {}
}

export class AgentBookingVisioQualification implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  } as { [binding: string]: string };
  controller = [AgentBookingVisioQualificationCtrl];
}

export default MODULE_NAME;
